import React, { useEffect, useState } from "react";
import { getMenus } from "../../api/MenuService";
import { FaPlus, FaEye, FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getErrorMessage } from "../../utils/errorHandler"
export default function MenuList() {
  const navigate = useNavigate();
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("desc");

  const fetchMenus = async () => {
    try {
      setLoading(true);

      const res = await getMenus({
        search,
        sort,
      });

      setMenus(res?.data || []);
    } catch (error) {
      console.error("Failed to fetch menus", error);
      alert(getErrorMessage(error));
      setMenus([]);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchMenus();
  }, [search, sort]);
  return (
    <div className="container-fluid p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">Menu List</h5>

        <div className="d-flex align-items-center gap-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search menu..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: "220px" }}
          />

          <select
            className="form-select border-0"
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            style={{ width: "100px" }}
          >
            <option value="asc">ASC</option>
            <option value="desc">DESC</option>
          </select>

          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => navigate("/menu/add")}
          >
            <FaPlus />
            Add Menu
          </button>
        </div>
      </div>
      {loading && <p>Loading menus...</p>}
      {!loading && menus.length === 0 && (
        <p className="text-secondary">No menus found</p>
      )}
      <div className="row g-4 justify-content-start">
        {menus.map((menu) => {
          return (
            <div className="col-md-6 d-flex" key={menu._id}>
              <div
                className="w-100"
                style={{
                  borderRadius: "12px",
                  padding: "15px",
                  backgroundColor: "#ffffff",
                }}
              >
                <div className="d-flex align-items-start gap-4">
                  <div className="flex-grow-1">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="fw-semibold text-dark mb-0">
                        {menu.name}
                      </h5>
                      <div className="d-flex gap-3">
                        <button
                          className="border-0 bg-transparent p-0"
                          onClick={() =>
                            navigate(`/menu/view/${menu.name}`, {
                              state: {
                                menuId: menu._id,
                              },
                            })
                          }
                        >
                          <FaEye size={18} color="black" />
                        </button>
                        <button
                          className="border-0 bg-transparent p-0"
                          onClick={() =>
                            navigate(`/menu/edit/${menu.name}`, {
                              state: { menuId: menu._id },
                            })
                          }
                        >
                          <FaEdit size={18} color="black" />
                        </button>
                      </div>
                    </div>
                    <p className="mb-1">Slug: {menu.slug || "-"}</p>
                    <p className="mb-1">Type: {menu.type || "-"}</p>
                    <p className="mb-1">
                      Visible: {menu.visible ? "Yes" : "No"}
                    </p>
                    <p className="mb-1">Order: {menu.order ?? "-"}</p>
                    <p className="mb-1">
                      Parent Id: {menu.parentId || "No Parent"}
                    </p>
                    <p className="fw-medium mb-0 text-dark">
                      Status: {menu.status || "Inactive"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
